import React, {Component} from "react";
import InsertOrderTradeAdmin from "./InsertOrderTradeAdminView";
import {CatalogDateService} from "../../../../service/catalog/CatalogDateService";
import {ORDER_ADMIN_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {OrderAdminService} from "../../../../service/operation/orderAdmin/OrderAdminService";
import {Growl} from "primereact/growl";
import {withoutComma} from "../../../../utils/calculate/Amount";
import {validateNumberIntegersDecimals} from "../../../../utils/formatters/Numbers";

export default class InsertOrderTradeAdminContainer extends Component {
    constructor(props) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);

        super(props);

        this.catalogDateService = new CatalogDateService();
        this.orderAdminService = new OrderAdminService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.getMaxValueDate = this.getMaxValueDate.bind(this);
        this.saveDataOrderTrade = this.saveDataOrderTrade.bind(this);
        this.insertOrderTradeAdmin = this.insertOrderTradeAdmin.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.getExpirationDate = this.getExpirationDate.bind(this);

        this.state = {
            isLoading: true,
            today: today,
            maxValueDate: this.getMaxValueDate(),
            readOnlyLenderAccount: true,
            orderTrade: {
                catInstitutionLender: {},
                catInstitutionBorrower: {},
                catInstrument: {},
                catAccount: {},
                sobreTasa: 0,
                orderType: "today",
                fecValor: today,
                validDate: true,
                precio: '',
                copyPrice: '',
            },
        };

        this.accountDropDown = React.createRef();
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleCancel() {
        this.props.history.push({
            pathname: ORDER_ADMIN_ROUTE,
        });
    }

    handleReturnButton(response) {
        if (response.error !== '') {
            this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});

        } else {
            let message = {
                severity: 'success',
                summary: 'Éxito',
                detail: response.message,
            };

            this.props.history.push({
                pathname: ORDER_ADMIN_ROUTE,
                message: message,
            });
        }
    }

    getMaxValueDate() {
        this.loading(true);
        this.catalogDateService.getMaxValueDate().then(
            valueDate => {
                this.setState({
                    maxValueDate: new Date(valueDate[0])
                })
            });
    }

    saveDataOrderTrade(event) {
        const {name, value, id} = event.target;
        let orderTrade = this.state.orderTrade;
        orderTrade[name] = value;

        if (name === "catInstitutionLender") {
            this.loading(true);
            this.accountDropDown.current.getInstitutionAccountsById(
                value != null ? value.idInstitucion : 0
            );
            this.setState({
                readOnlyLenderAccount: false,
            });
            orderTrade['catAccount'] = {};
        }else if (name === "plazo") {
            if (value !== '' && value !== '0') {
                this.getExpirationDate(orderTrade)
            }
        } else if (name === "fecValor") {
            if (orderTrade['plazo'] !== '' && orderTrade['plazo'] !== '0') {
                this.getExpirationDate(orderTrade);
            }
            if(value > this.state.today){
                orderTrade['precio'] = '';
                orderTrade['disabledRadio'] = true;
            }else{
                orderTrade['disabledRadio'] = false;
                orderTrade['precio'] = this.state.orderTrade.copyPrice;
            }
        }else if(name === 'catInstrument'){
            orderTrade['copyPrice'] = value.precio24 ? value.precio24.toFixed(6) : '';
            if(this.state.orderTrade.fecValor > this.state.today){
                orderTrade['precio'] = '';
                orderTrade['disabledRadio'] = true;
            }else{
                orderTrade['disabledRadio'] = false;
                orderTrade['precio'] = value.precio24 ? value.precio24.toFixed(6) : '';
            }
        } else  if (name === "tasa" || name === "sobretasa") {
            let numValue = Number(withoutComma(value));
            orderTrade[name] = validateNumberIntegersDecimals(numValue, id, 2);
        }

        this.setState({orderTrade: orderTrade,})
    }

    getExpirationDate(orderTrade) {
        this.loading(true);
        let plazo = orderTrade.plazo ?
            orderTrade.plazo : this.state.orderTrade.plazo;
        let fecValor = orderTrade.fecValor ?
            orderTrade.fecValor : this.state.orderTrade.fecValor;
        this.catalogDateService.getMaturityDate(withoutComma(plazo.toString()), fecValor)
            .then(dateInfo => {
                let orderTradeAux = this.state.orderTrade;
                orderTradeAux['fechaVence'] = dateInfo[0];
                orderTradeAux['validDate'] = dateInfo[1] === 1;
                this.setState({
                    orderTrade: orderTradeAux
                });
            });
        this.loading(false);
    }

    validateGeneralFields() {
        let fields = [];

        if (this.state.orderTrade.catInstrument.idEmisora === undefined) {
            fields.push("Emisora");
        }

        if (this.state.orderTrade.cantidad === undefined || this.state.orderTrade.cantidad === "" || this.state.orderTrade.cantidad === "0") {
            fields.push("Títulos");
        }

        if (this.state.orderTrade.tasa === undefined || this.state.orderTrade.tasa === "" || this.state.orderTrade.tasa === "0") {
            fields.push("Tasa");
        }

        if (this.state.orderTrade.sobreTasa === undefined || this.state.orderTrade.sobreTasa === "" || this.state.orderTrade.sobreTasa === "0") {
            fields.push("SobreTasa");
        }

        if (this.state.orderTrade.plazo === undefined || this.state.orderTrade.plazo === "" || this.state.orderTrade.plazo === "0") {
            fields.push("Plazo");
        }

        if (this.state.orderTrade.fecValor === undefined || this.state.orderTrade.fecValor === "") {
            fields.push("Fecha Valor");
        }
        return fields;
    }

    validateLenderFields() {
        let fieldsLender = [];
        if (this.state.orderTrade.catAccount.cuenta === undefined) {
            fieldsLender.push("Cuenta");
        }

        return fieldsLender;
    }

    insertOrderTradeAdmin() {
        const lender = this.state.orderTrade.catInstitutionLender;
        const borrower = this.state.orderTrade.catInstitutionBorrower;

        let fields = this.validateGeneralFields();

        if (fields.length === 0) {
            if (lender != null && lender.idInstitucion > 0 && borrower != null && borrower.idInstitucion > 0) {
                let fieldsLender = this.validateLenderFields();

                if (fieldsLender.length === 0) {
                    this.loading(true);
                    this.orderAdminService.insertTradeAdmin(
                        this.state.orderTrade.catInstitutionLender.idInstitucion,
                        this.state.orderTrade.catInstitutionBorrower.idInstitucion,
                        this.state.orderTrade.catInstrument.idEmisora,
                        this.state.orderTrade.catAccount.cuenta,
                        this.state.orderTrade.cantidad,
                        this.state.orderTrade.plazo,
                        this.state.orderTrade.tasa * 100,
                        this.state.orderTrade.sobreTasa * 100,
                        this.state.orderTrade.orderType === "today" ? 'D' : 'S',
                        this.state.orderTrade.fecValor,
                    ).then(
                        res => {
                            this.loading(false);
                            this.handleReturnButton(res);
                        }
                    );
                } else {
                    this.showMessage(fieldsLender);
                }
            } else {
                if (lender != null && lender.idInstitucion > 0) {
                    let fieldsLender = this.validateLenderFields();

                    if (fieldsLender.length === 0) {
                        this.loading(true);
                        this.orderAdminService.insertLenderOrderAdmin(
                            this.state.orderTrade.catInstitutionLender.idInstitucion,
                            this.state.orderTrade.catInstrument.idEmisora,
                            this.state.orderTrade.catAccount.cuenta,
                            this.state.orderTrade.cantidad,
                            this.state.orderTrade.plazo,
                            this.state.orderTrade.tasa * 100,
                            this.state.orderTrade.sobreTasa * 100,
                            this.state.orderTrade.orderType === "today" ? 'D' : 'S',
                            this.state.orderTrade.fecValor,
                            this.state.orderTrade.idFolioSolVal
                        ).then(
                            res => {
                                this.loading(false);
                                this.handleReturnButton(res);
                            }
                        );
                    } else {
                        this.showMessage(fieldsLender);
                    }
                } else {
                    if (borrower != null && borrower.idInstitucion > 0) {
                        this.loading(true);
                        this.orderAdminService.insertBorrowerOrderAdmin(
                            this.state.orderTrade.catInstitutionBorrower.idInstitucion,
                            this.state.orderTrade.catInstrument.idEmisora,
                            this.state.orderTrade.cantidad,
                            this.state.orderTrade.plazo,
                            this.state.orderTrade.tasa * 100,
                            this.state.orderTrade.sobreTasa * 100,
                            this.state.orderTrade.orderType === "today" ? 'D' : 'S',
                            this.state.orderTrade.fecValor,
                            this.state.orderTrade.idFolioValPrestable
                        ).then(
                            res => {
                                this.loading(false);
                                this.handleReturnButton(res);
                            }
                        );
                    }
                }
            }
        } else {
            this.showMessage(fields);
        }
    }

    showMessage(fields) {
        let message = "Favor de revisar los siguientes campos: ";

        fields.map(field => {
            message = message + field + ', ';
            return '';
        });

        let lastTwoChar = message.slice(-2);

        if (lastTwoChar === ', ') {
            message = message.slice(0, -2);
        }

        this.growl.show({severity: 'error', summary: 'Error.', detail: message});
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <InsertOrderTradeAdmin
            isLoading={this.state.isLoading}
            loading={this.loading}
            messagesGrowl={messagesGrowl}
            handleReturnButton={this.handleReturnButton}
            accountDropDown={this.accountDropDown}
            today={this.state.today}
            maxValueDate={this.state.maxValueDate}
            catInstitutionCatalog={this.state.catInstitutionCatalog}
            catInstrumentCatalog={this.state.catInstrumentCatalog}
            catInstitutionAccountCatalog={this.state.catInstitutionAccountCatalog}
            orderTrade={this.state.orderTrade}
            saveDataOrderTrade={this.saveDataOrderTrade}
            insertOrderTradeAdmin={this.insertOrderTradeAdmin}
            readOnlyLenderAccount={this.state.readOnlyLenderAccount}
            handleCancel={this.handleCancel}
        />
    }
};